<ng-template>
  <ng-content></ng-content>
  <ng-template [cdkPortalOutlet]="portal"></ng-template>
</ng-template>
